import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { bulkAddTags, bulkRemoveTags, bulkOverwriteTags } from '@/api/jobs'
import BulkUpdateWrapper from '@/components/common/BulkUpdateWrapper.vue'
import TicketTags from '@/components/tickets/TicketTags.vue'

interface Data {
  tagUpdateOption: 'add' | 'remove' | 'overwrite'
  selectedTags: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUpdateTagForm',
  props: {
    buttonLabel: null,
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
}

const data: Data = reactive({
  tagUpdateOption: 'add',
  selectedTags: [],
})

const saving = ref(false)
const error = ref(false)



const save = async () => {
  saving.value = true
  if (data.tagUpdateOption === 'add') {
    await addTags()
  } else if (data.tagUpdateOption === 'remove') {
    await removeTags()
  } else {
    await overwriteTags()
  }
}

const addTags = async () => {
  try {
    await bulkAddTags(
      props.selectedJobs.map((j) => j.number),
      data.selectedTags
    )
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) => {
      const newTags = job.tags
      for (const tag of data.selectedTags) {
        if (!job.tags.includes(tag)) {
          newTags.push(tag)
        }
      }
      return Object.assign(job, {
        tags: newTags,
      })
    })
    emits('updated', { message: 'Tag updated', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}
const removeTags = async () => {
  try {
    await bulkRemoveTags(
      props.selectedJobs.map((j) => j.number),
      data.selectedTags
    )
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        tags: job.tags.filter((t) => !data.selectedTags.includes(t)),
      })
    )
    emits('updated', { message: 'Tag updated', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}
const overwriteTags = async () => {
  try {
    await bulkOverwriteTags(
      props.selectedJobs.map((j) => j.number),
      data.selectedTags
    )
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        tags: data.selectedTags,
      })
    )
    emits('updated', { message: 'Tag updated', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}
const handleUpdateTags = (tagsList: string[]) => {
  data.selectedTags = tagsList
}
const introText = computed(() => {
  if (data.tagUpdateOption === 'add') {
    return 'Add tags...'
  } else if (data.tagUpdateOption === 'remove') {
    return 'Remove existing tags...'
  } else if (data.tagUpdateOption === 'overwrite') {
    return 'Change the tags to...'
  } else {
    return 'Unknown options'
  }
})
const dismiss = () => emits('dismiss')
const clearSnackbar = () => (error.value = false)
const clearSelectedTags = (event: string) => {
  if (event === 'remove') {
    data.selectedTags = []
  }
}

return { __sfc: true,data, props, saving, error, emits, save, addTags, removeTags, overwriteTags, handleUpdateTags, introText, dismiss, clearSnackbar, clearSelectedTags, BulkUpdateWrapper, TicketTags }
}

})